import React from "react";
import ChatMessageItem from "./ChatMessageItem";
import { ChatMessage } from "../ChatComponent";

interface MessageListProps {
  chatMessages: ChatMessage[];
  currentUser: any;
  thinkingDots: string;
}

const MessageList = React.memo(function MessageList({
  chatMessages,
  currentUser,
  thinkingDots,
}: MessageListProps) {
  return (
    <ul>
      {chatMessages.map((message, index) => (
        <ChatMessageItem
          key={index}
          message={message}
          currentUser={currentUser}
          thinkingDots={thinkingDots}
        />
      ))}
    </ul>
  );
});

export default MessageList;
